import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  Router,
  RouterOutlet,
  ActivatedRoute,
  NavigationEnd,
} from "@angular/router";
import { HeaderComponent } from "../../shared/header/header.component";
import { FooterComponent } from "../../shared/footer/footer.component";
import { filter, map, mergeMap } from "rxjs/operators";

@Component({
  selector: "app-login-layout",
  templateUrl: "./login-layout.component.html",
  styleUrls: ["./login-layout.component.scss"],
  standalone: true,
  imports: [HeaderComponent, CommonModule, RouterOutlet, FooterComponent],
})
export class LoginLayoutComponent implements OnInit {
  pageName: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === "primary"),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        // Update pageName and page title
        this.pageName = data.pageName || "";
      });
  }

  ngOnInit() {}
}
